import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { App } from 'wall/components/app';

let root = document.createElement('div');
root.classList.add('base');
document.body.appendChild(root);

ReactDOM.render(
  <App />,
  root,
);



// WEBPACK FOOTER //
// ./src/index.tsx